import React, { useState } from 'react'
import { Button, Icons, Input } from '@pankod/refine-antd'

type TMaskedTextInputProps = React.ComponentProps<typeof Input>

type TMaskedInputStyle = React.CSSProperties & {
  WebkitTextSecurity?: 'disc' | 'none'
}

export const MaskedTextInput: React.FC<TMaskedTextInputProps> = ({
  style,
  suffix,
  ...props
}) => {
  const [visible, setVisible] = useState(false)

  const inputStyle = {
    ...style,
    WebkitTextSecurity: visible ? 'none' : 'disc',
  } as TMaskedInputStyle

  const visibilityToggle = (
    <Button
      aria-label={visible ? 'Sembunyikan passphrase' : 'Tampilkan passphrase'}
      htmlType="button"
      icon={visible ? <Icons.EyeInvisibleOutlined /> : <Icons.EyeOutlined />}
      size="small"
      style={{ border: 0, boxShadow: 'none', height: 22, padding: 0 }}
      type="text"
      onClick={() => setVisible((currentVisible) => !currentVisible)}
      onMouseDown={(event) => event.preventDefault()}
    />
  )

  return (
    <Input
      {...props}
      autoCapitalize="off"
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      style={inputStyle}
      suffix={
        suffix ? (
          <>
            {suffix}
            {visibilityToggle}
          </>
        ) : (
          visibilityToggle
        )
      }
      type="text"
    />
  )
}
